module.exports = __webpack_public_path__ + "img/kh.kh09c4969.svg";